import { useEffect, useState } from "react";
import { isSubscriptionExpired, subscriptionPolicy } from "src/configs/subscription-access";

/** Close paid views when a trial ends, even without a navigation or another API request. */
export const useSubscriptionExpired = (user) => {
  const [clock, setClock] = useState(0);
  const expired = isSubscriptionExpired(user);
  useEffect(() => {
    if (!subscriptionPolicy.enforced || expired || user?.isAdmin || !Number.isFinite(user?.usage?.to)) return undefined;
    const delay = Math.min(2147483647, Math.max(1, user.usage.to - Date.now() + 1));
    const timer = window.setTimeout(() => setClock(value => value + 1), delay);
    return () => window.clearTimeout(timer);
  }, [expired, user?.isAdmin, user?.usage?.to, clock]);
  return expired;
};
